import liveswitch from "fm.liveswitch";
import ChannelConnectionEvents from "./ChannelConnectionEvents";

export default class Screenshare {
    private localScreenMedia!: liveswitch.LocalMedia;
    private screenshareUpstreamConnection?: liveswitch.SfuUpstreamConnection;
    private events: ChannelConnectionEvents;
    private channel: liveswitch.Channel;
    private errorLogger: (err: string) => void;

    constructor(channel: liveswitch.Channel, events: ChannelConnectionEvents, errorLogger: (err: string) => void) {
        this.channel = channel;
        this.events = events;
        this.errorLogger = errorLogger;
        console.log("CHANNEL:", this.channel);
    }

    public toggleScreenshare(): void {
        if (this.localScreenMedia === undefined) {
            const width = 1280;
            const height = 720;
            const fps = 20;

            const videoConfig = new liveswitch.VideoConfig(width, height, fps);
            this.localScreenMedia = new liveswitch.LocalMedia(false, videoConfig, true);
        }

        if (this.localScreenMedia.getState() === liveswitch.LocalMediaState.New || this.localScreenMedia.getState() === liveswitch.LocalMediaState.Stopped) {
            this.startScreenshare();
        } else {
            this.stopScreenshare();
        }
    }

    private startScreenshare(): void {
        this.localScreenMedia.start().then(_ => {
            this.localScreenMedia.addOnVideoStopped(() => {
                this.stopScreenshare();
            });
            
            this.openScreenshareUpstreamConnection(this.localScreenMedia);

            this.notifyScreenshareUpdate();
        }).fail(ex => this.errorLogger(ex.message));
    }

    public stopScreenshare(): void {
        this.screenshareUpstreamConnection?.close().then(_ => {
            this.localScreenMedia.stop();

            this.screenshareUpstreamConnection = undefined;
            this.notifyScreenshareUpdate();
        }).fail(ex => this.errorLogger(ex.message));
    }

    private notifyScreenshareUpdate() {
        let connectionData = null;
        if (this.screenshareUpstreamConnection) {
            const size = this.localScreenMedia.getVideoSize();
            connectionData = {
                id: this.screenshareUpstreamConnection.getId(),
                userId: this.channel.getUserId(),
                deviceId: this.channel.getDeviceId(),
                userAlias: this.channel.getUserAlias(),
                roles: [...this.channel.getClientRoles(), "screenshare"],
                view: this.localScreenMedia.getView(),
                isLocal: true,
                isScreen: true,
                isXR: false,
                color: '',
                videoWidth: size.getWidth(),
                videoHeight: size.getHeight()
            };
        }

        this.events.notify("onscreenshareupdate", connectionData);
    }
    
    private openScreenshareUpstreamConnection(localMedia: liveswitch.LocalMedia) {
        const audioStream = new liveswitch.AudioStream(localMedia);
        const videoStream = new liveswitch.VideoStream(localMedia);

        this.screenshareUpstreamConnection = this.channel.createSfuUpstreamConnection(audioStream, videoStream);

        this.screenshareUpstreamConnection.addOnStateChange(conn => {
            console.log(`Upstream connection is ${new liveswitch.ConnectionStateWrapper(conn.getState()).toString()}.`);

            if (conn.getState() === liveswitch.ConnectionState.Closing || conn.getState() === liveswitch.ConnectionState.Failing) {
                if (conn.getRemoteClosed()) {
                    console.log(`Upstream connection ${conn.getId()} was closed`);
                }
            } else if (conn.getState() === liveswitch.ConnectionState.Failed) {
                this.openScreenshareUpstreamConnection(localMedia);
            }
        });

        this.screenshareUpstreamConnection.open();
    }
}